import type { HubSpotInvoiceStatus } from 'client/types.gen';

export type InvoiceStatusSeverity = 'amber' | 'red';

const SEVERITY: Record<HubSpotInvoiceStatus, InvoiceStatusSeverity | null> = {
  '<30 Days Overdue': 'amber',
  '30 Days Overdue': 'amber',
  '60 Days Overdue': 'red',
  '90 Days Overdue': 'red',
  'Good Standing': null,
};

export const getInvoiceStatusSeverity = (
  status?: HubSpotInvoiceStatus | null,
): InvoiceStatusSeverity | null => (status ? SEVERITY[status] : null) ?? null;

export const isInvoiceOverdue = (
  status?: HubSpotInvoiceStatus | null,
): boolean => getInvoiceStatusSeverity(status) !== null;

/** Display order for filters/selects; labels come from
 * `form.default.invoice_status.option.*` translations. */
export const INVOICE_STATUS_ORDER: HubSpotInvoiceStatus[] = [
  'Good Standing',
  '<30 Days Overdue',
  '30 Days Overdue',
  '60 Days Overdue',
  '90 Days Overdue',
];

export const getHubSpotContactUrl = (hubspotId: string): string | null => {
  const portalId = import.meta.env.VITE_APP_HUBSPOT_PORTAL_ID;
  return portalId
    ? `https://app.hubspot.com/contacts/${portalId}/record/0-1/${hubspotId}`
    : null;
};
